import { View, styled, ScrollView, useTheme } from 'tamagui'
import { useState, useMemo } from 'react'
import { exploreServers } from '@/mocks/explore'
import { ExploreServerCard } from './ExploreServerCard'
import { ExploreCategoryFilter } from './ExploreCategoryFilter'
import type { ExploreCategory } from '@/types'

const Container = styled(View, {
  flex: 1,
  flexDirection: 'column',
})

const SearchBar = styled(View, {
  paddingHorizontal: 24,
  paddingTop: 16,
  paddingBottom: 12,
})

const Grid = styled(View, {
  padding: 24,
  paddingTop: 8,
  // @ts-expect-error -- web grid
  style: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
    gap: 16,
  },
})

export function ExploreView() {
  const [query, setQuery] = useState('')
  const [activeCategory, setActiveCategory] = useState<ExploreCategory | null>(null)
  const theme = useTheme()

  const filtered = useMemo(() => {
    let results = exploreServers
    if (activeCategory) {
      results = results.filter(s => s.category === activeCategory)
    }
    if (query) {
      const q = query.toLowerCase()
      results = results.filter(s =>
        s.name.toLowerCase().includes(q) ||
        s.description.toLowerCase().includes(q) ||
        s.tags.some(t => t.toLowerCase().includes(q))
      )
    }
    return results
  }, [query, activeCategory])

  return (
    <Container>
      <SearchBar>
        <input
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Search public servers..."
          style={{
            background: 'transparent',
            border: `1px solid ${theme.borderDefault?.val || '#2A3142'}`,
            borderRadius: 8,
            padding: '10px 14px',
            color: theme.surfaceForeground?.val || '#E2E8F0',
            fontFamily: '$fontBody',
            fontSize: 14,
            outline: 'none',
            width: '100%',
            boxSizing: 'border-box',
          }}
        />
      </SearchBar>

      <View paddingHorizontal={24}>
        <ExploreCategoryFilter active={activeCategory} onSelect={setActiveCategory} />
      </View>

      <ScrollView flex={1} showsVerticalScrollIndicator={false}>
        <Grid>
          {filtered.map((server) => (
            <ExploreServerCard key={server.id} server={server} />
          ))}
        </Grid>
      </ScrollView>
    </Container>
  )
}
